<template>
	<div class="flex flex--align-center flex--gap-large">
		<label
			for="date-sort"
			class="form__label form__label--filter"
		>
			Sort by
		</label>
		<div class="flex flex--gap-small">
			<Datepicker
				:model-value="date.custom"
				:max-date="getToday"
				:time-config="{ enableTimePicker: false }"
				:clearable="false"
				auto-apply
				range
				:year-range="[2014, ( new Date() ).getFullYear()]"
				:config="{ closeOnAutoApply: false }"
				@update:model-value="handleDatepickerSelect"
			>
				<template #dp-input="{ isMenuOpen }">
					<button
						class="datepicker-trigger"
						:class="{ 'datepicker-trigger--expand': isMenuOpen }"
					>
						<p class="datepicker-trigger__label">
							<span>{{ display_value }}</span>
						</p>
					</button>
				</template>
				<template #top-extra>
					<!-- Insert other filters here -->
					<div class="flex flex--align-center flex--gap-medium mb-16">
						<label
							v-for="option in sorting.options"
							:key="`sorting-${option.value}`"
							:for="option.value"
							class="form__radio form__radio--small form__radio--inline"
						>
							<input
								type="radio"
								:id="option.value"
								name="sorting"
								:value="option.value"
								v-model="sorting.selected"
								@input="handleSortingSelect"
							/>
							{{ option.label }}
						</label>
					</div>

					<div class="flex grid grid--xs flex--wrap">
						<div
							v-for="option, i in date.options"
							:key="`period-${option.value}`"
							class="mb-8"
							:class="i < 2 ? 'grid__item a6-12' : 'grid__item a4-12'"
						>
							<button
								class="button button--smaller button--stretch button--squared"
								:class="{ 'button--selected': option.value === date.selected }"
								@click="handlePeriodSelect( option.value )"
							>
								{{ option.label }}
							</button>
						</div>
					</div>
				</template>
			</Datepicker>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useProjectFiltersStore } from '../../stores/project-filters';

import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';

const filters_store = useProjectFiltersStore();

const {
	setSelectedDateRange,
	setSelectedSorting,
	resetPagination,
	updateQueryStringFromFilters
} = filters_store;

const { date, sorting } = storeToRefs( filters_store );

const handleSortingSelect = ( e ) => {
	setSelectedSorting( e.target.value );
	resetPagination();
	updateQueryStringFromFilters();
};

const handlePeriodSelect = ( value ) => {
	setSelectedDateRange( value, false );
	resetPagination();
	updateQueryStringFromFilters();
}

const handleDatepickerSelect = ( data ) => {
	if ( !data || !data.length === 2 || data[1] === null ) {
		return;
	}
	setSelectedDateRange( data.map( date => moment( date ).format( 'YYYY-MM-DD' ) ), true );
	resetPagination();
	updateQueryStringFromFilters();
};

const getToday = () => {
	return ( new Date() ).setHours( 23, 59, 59, 999 );
};

const display_period = computed( () => {
	if ( date.value.selected === 'custom' && date.value.custom && date.value.custom.length === 2 ) {
		return getDatesFormat( date.value.custom );
	}
	return date.value.options.find( option => option.value === date.value.selected )?.label ?? 'All time';
} );

const display_value = computed( () => {
	const display_sorting = sorting.value.options.find( option => option.value === sorting.value.selected )?.label ?? 'Newest first';

	return `${display_period.value} (${display_sorting.toLowerCase()})`;
} );

const getDatesFormat = dates => {
	const date_1 = dates[0];
	const date_2 = dates[1];

	if ( date_1 === date_2 ) {
		return moment( date_1 ).format( 'DD/MM/YYYY' );
	}
	return moment( date_1 ).format( 'DD/MM/YYYY' ) + ' - ' + moment( date_2 ).format( 'DD/MM/YYYY' );
};
</script>